import { ReactElement } from 'react';
import { UserListCard } from '@components/lms/userList/components/userListCard/userListCard';
import { useInfiniteScroll } from '@components/common';
import { Wrapper } from '@components/common/Wrapper/wrapper';
import { useLmsUserLeadsRxDb } from '@services/hooks/lms/userLeads/useLmsUserLeadsRxDb';
import { NoDataFound } from '@components/common/no-data-found/noDataFound';
import '@assets/styles/pages/lms/user-list.scss';
import { useCloseLeadsPopup } from '@store/closeLeadsPopupStore';
import { CloseLeadsModal } from '@components/common/close-leads/closeLeadsPopUp';
import { Modal } from '@components/common/modal/modal';
export const PendingLeadsListPage = (): ReactElement => {
	const { isOpen, setModal } = useCloseLeadsPopup((state) => state);

	const { result, fetchMore } = useLmsUserLeadsRxDb({
		searchValue: '',
		sortBy: '',
		createddate: [null, null],
		status: 'Pending', // Default to Pending status
		competition_tag: false,
		source: '',
	});

	useInfiniteScroll(() => {
		fetchMore();
	});

	return (
		<Wrapper isLoaderVisible={false} isError={null}>
			<>
				<div className="common-list-card common-user-list-card">
					<ul className="row">
						{result && result.length !== 0 ? (
							result.map((user) => <UserListCard key={user._data.id} data={user._data} isHideButton={true} />)
						) : (
							<NoDataFound message="No Pending Leads Found!" />
						)}
					</ul>
				</div>
				<Modal
					modalOpen={isOpen}
					modalId={'closeLeads'}
					onModalClose={() => {
						setModal(false);
					}}
					className="dialog-sm close-site-popup dialog-conform"
				>
					<CloseLeadsModal />
				</Modal>
			</>
		</Wrapper>
	);
};
